import { render, staticRenderFns } from "./Certificate_Search.vue?vue&type=template&id=bbc59246&scoped=true&"
import script from "./Certificate_Search.vue?vue&type=script&lang=js&"
export * from "./Certificate_Search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc59246",
  null
  
)

export default component.exports